// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import { sessionTimeoutWarning } from 'components/Notifications'
import { logIn, setSessionTimeout } from 'helpers/auth'
import { hide, warning } from 'react-notification-system-redux'
import { assignUserData } from 'redux/modules/user/actions'
import { SESSION_TIMEOUT_WARNING_NOTIFICATION_ID } from 'components/Notifications/common/sessionTimeoutWarning/constants'

const setUserAndAuthToken = ({ authentication, user }) => async (dispatch, getState) => {
  const currentUserState = getState().user

  // if they exist, clear out the timeouts for these since we're about to create new ones.
  clearTimeout(currentUserState.get('sessionTimeout'))
  clearTimeout(currentUserState.get('renewSessionMessageTimeout'))

  const {
    expirationDate,
    jwtToken,
  } = authentication

  // hide the session timeout warning notification if it's showing.
  dispatch(hide(SESSION_TIMEOUT_WARNING_NOTIFICATION_ID))

  // ten minutes before being logged out, this notifies the user that
  // they'll need to reauthenticate or will be logged out.
  const notificationDate = expirationDate - (Date.now() + (10 * 60000))

  const renewSessionMessageTimeout = setTimeout(() => {
    dispatch(warning(sessionTimeoutWarning(expirationDate)))
  }, notificationDate)

  const sessionTimeout = setSessionTimeout(expirationDate)

  await logIn(jwtToken, expirationDate)

  await dispatch(assignUserData({
    ...user,
    renewSessionMessageTimeout,
    sessionTimeout,
  }))
}

export default setUserAndAuthToken
